import { __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import Divider from '../Divider/Divider.component.js';
import styles from './Dropdown.module.scss.js';

var DropdownOption = function (_a) {
    var _b;
    var selectProps = _a.selectProps, innerRef = _a.innerRef, innerProps = _a.innerProps, children = _a.children, data = _a.data, label = _a.label, isFocused = _a.isFocused;
    var caption = data.caption, rightLabel = data.rightLabel, isDisabled = data.isDisabled;
    var withDividers = selectProps.withDividers;
    var isSelected = ((_b = selectProps.value) === null || _b === void 0 ? void 0 : _b.label) === children;
    return (React__default.createElement("div", __assign({ ref: innerRef }, innerProps, { className: clsx(styles.Option, withDividers && styles.Option___divider), role: "option" }),
        React__default.createElement("div", { className: clsx(styles.Option_content, isSelected && styles.Option_content___selected, isDisabled && styles.Option_content___disabled, isFocused && styles.Option_content___focused), "data-testid": label ? "".concat(label, "Option") : undefined },
            React__default.createElement("div", { className: styles.Content },
                children,
                rightLabel || (React__default.createElement("div", { className: styles.Content_caption }, caption)))),
        withDividers && React__default.createElement(Divider, { className: styles.Option_divider })));
};
DropdownOption.displayName = 'DropdownOption';

export { DropdownOption as default };
